import React from 'react';

import FormRegister from '../forms/FormRegister.jsx';
import { useHttpStatus } from '~/commons/hooks';

import meta from '../../config/meta';

const PageRegister = () => {
  const [res, req] = useHttpStatus();

  meta.set({ title: '新帳戶註冊' });

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        {res.status === 'success' ? (
          <div className="col-md-6 text-center">
            <h4>
              感謝你的登記!
              <br />
              驗證郵件已發送到您的帳戶登記郵箱。
            </h4>
            <p className="mt-4">
              查看您的郵件點擊驗證連結即可登入網站
            </p>
          </div>
        ) : (
          <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <h2 className="mb-4">登記</h2>
            <FormRegister
              res={res}
              onSubmit={(values) => req({
                method: 'post',
                url: '/api/core/registrants',
                data: values,
              })}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PageRegister;
